export function getAutoHorizontalAlignment(domRect) {
    if (!domRect) {
        return undefined;
    }
    var viewportWidth = document.documentElement.clientWidth;
    var xCenter = viewportWidth / 2;
    var triggerCenter = domRect.left + domRect.width / 2;
    if (Math.abs(triggerCenter - xCenter) < 1) {
        return 'center';
    }
    if (triggerCenter < xCenter) {
        return 'start';
    }
    return 'end';
}
//# sourceMappingURL=getAutoHorizontalAlignment.js.map